

// import React from 'react';
// import { GoogleMap, LoadScript } from '@react-google-maps/api';

// const Map = () => {
//   const center = {
//     lat: 28.510980,
//     lng: 77.018220
//   };

//   const containerStyle = {
//     width: '625px',
//         height: '350px'
//   };


//   return (
//     <div >
//       <LoadScript googleMapsApiKey={process.env.MAP_API_KEY}>
//         <GoogleMap
//           mapContainerStyle={containerStyle}
//           center={center}
//           zoom={12}
//         >
//           {/* Child components, such as markers, info windows, etc. */}
//           <></>
//         </GoogleMap>
//       </LoadScript>
//     </div>
//   );
// }

// export default Map;

import React from 'react';

const Map = () => {
  return (
    <div className="map_div">
      <div className="mapouter">
        <div className="gmap_canvas">
          <iframe
            className="gmap_iframe"
            width="100%"
            height="100%"
            frameBorder="0"
            scrolling="no"
            marginHeight="0"
            marginWidth="0"
            src="https://maps.google.com/maps?width=650&amp;height=366&amp;hl=en&amp;q=Crest Digitel Private Limited 278, Udyog Vihar II Rd, Phase II, Udyog Vihar, Sector 20, Gurugram, Haryana 122022&amp;t=&amp;z=13&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default Map;
